import { render, staticRenderFns } from "./NetaListMultiEventComponent.vue?vue&type=template&id=96d20012&scoped=true&"
import script from "./NetaListMultiEventComponent.vue?vue&type=script&lang=js&"
export * from "./NetaListMultiEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaListMultiEventComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaListMultiEventComponent.vue?vue&type=style&index=1&id=96d20012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d20012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96d20012')) {
      api.createRecord('96d20012', component.options)
    } else {
      api.reload('96d20012', component.options)
    }
    module.hot.accept("./NetaListMultiEventComponent.vue?vue&type=template&id=96d20012&scoped=true&", function () {
      api.rerender('96d20012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-list/NetaListMultiEventComponent.vue"
export default component.exports